import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'interfaces';
import { directChatInitialState } from './slice';

const selectDomain = (state: RootState) => state['feature/direct-chat'] || directChatInitialState;

export const selectDirectChatLoading = createSelector(
  [selectDomain],
  (state) => state.loading,
);

export const selectDirectChatConversationLoading = createSelector(
  [selectDomain],
  (state) => state.conversationLoading,
);

export const selectDirectChatConversations = createSelector(
  [selectDomain],
  (state) => state.conversations,
);

export const selectDirectChatConversationsPage = createSelector(
  [selectDomain],
  (state) => state.conversationsPage,
);

export const selectDirectChatConversationsTotal = createSelector(
  [selectDomain],
  (state) => state.conversationsTotal,
);

export const selectDirectChatConversationsLoadingMore = createSelector(
  [selectDomain],
  (state) => state.conversationsLoadingMore,
);

export const selectDirectChatConversationId = createSelector(
  [selectDomain],
  (state) => state.conversationId,
);

export const selectDirectChatSingleConversation = createSelector(
  [selectDomain],
  (state) => state.conversation,
);

export const selectDirectChatFilters = createSelector(
  [selectDomain],
  (state) => state.filters,
);

export const selectTenantUsers = createSelector(
  [selectDomain],
  (state) => state.tenantUsers,
);

export const selectTenantUsersLoading = createSelector(
  [selectDomain],
  (state) => state.tenantUsersLoading,
);

export const selectTenantUsersPage = createSelector(
  [selectDomain],
  (state) => state.tenantUsersPage,
);

export const selectTenantUsersTotal = createSelector(
  [selectDomain],
  (state) => state.tenantUsersTotal,
);

export const selectTenantUsersKeyword = createSelector(
  [selectDomain],
  (state) => state.tenantUsersKeyword,
);

export const selectRecentUsers = createSelector(
  [selectDomain],
  (state) => state.recentUsers,
);

export const selectRecentUsersLoading = createSelector(
  [selectDomain],
  (state) => state.recentUsersLoading,
);

export const selectDirectChatSendMessageLoading = createSelector(
  [selectDomain],
  (state) => state.sendMessageLoading,
);
